<script setup lang="ts">
import { cn } from '#shared/utils';
import {
  NavigationMenuRoot,
  type NavigationMenuRootEmits,
  type NavigationMenuRootProps,
  useForwardPropsEmits,
} from 'radix-vue';
import { computed, type HTMLAttributes, provide } from 'vue'; // ⬅ add provide
import NavigationMenuViewport from './NavigationMenuViewport.vue';

const props = defineProps<
  NavigationMenuRootProps & { class?: HTMLAttributes['class']; viewport?: boolean } // ⬅ add prop
>();

const emits = defineEmits<NavigationMenuRootEmits>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;
  return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);

// ⬅ expose to children whether a viewport is used
const hasViewport = computed(() => props.viewport !== false);
provide('navMenuHasViewport', hasViewport);
</script>

<template>
  <NavigationMenuRoot
    v-bind="forwarded"
    :viewport="props.viewport"
    :class="cn('relative z-10 inline-flex items-center', props.class)"
  >
    <!-- :class="cn('relative z-10 flex max-w-max flex-1 items-center justify-center', props.class)" -->
    <slot />
    <NavigationMenuViewport v-if="hasViewport" />
    <!-- ⬅ conditional -->
  </NavigationMenuRoot>
</template>
